import { Suspense } from 'react';
import container from './container';
import { findMbox } from './offers';
import { useAdobeExperiments } from '../../experiments/AdobeExperiment/AdobeExperimentProvider';
import { getFullExperimentString } from '../../experiments/getExperimentString';
import { sendQuantumEvent } from '../../utilities/utils';
/**
 * Use this to replace an existing component with an experimental component
 * @example
 *    withExperiment(QuotationHeroSection, 'quotations-batchrequote-mbox');
 * @param {ReactNode} Component - The control component.
 * @param {string} mbox - The name of the mbox configured in Adobe Form Based Composer.
 */
const withExperiment = (Component: any, mbox: any) => {
    /* eslint-disable react/prop-types */
    return (props: any) => {
        const state = useAdobeExperiments();

        if (state.initialising) return <Component {...props} />;

        const fallback = (
            <div style={{ opacity: '0' }}>
                <Component {...props} />
            </div>
        );

        if (state.fetching) return fallback; //emulate Adobe pre-hiding snippet at element level

        const experimentVariant = getFullExperimentString(state);
        if (experimentVariant) sendQuantumEvent(96, 0, true, { experimentVariant });

        const variant = findMbox(state.data, mbox)?.content?.variant;

        if (!variant) return <Component {...props} />;

        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '
        const Experiment = container[mbox]?.[variant];

        if (!Experiment) {
            return <Component {...props} />;
        }

        return (
            <Suspense fallback={fallback}>
                <Experiment {...props} />
            </Suspense>
        );
    };
};

export default withExperiment;
